import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { reviewSort: Boolean }

  get parameterName () {
    return this.reviewSortValue ? 'sort_key' : 'sort_order'
  }

  initialize () {
    if (!('URLSearchParams' in window)) return

    const urlParams = new URLSearchParams(location.search)
    const currentSortKey = urlParams.get(this.parameterName)
    // sort_order未指定時は先頭タブ（おすすめ順）をアクティブにする
    const firstTabValue = this.element.querySelector('[data-sort-value]')?.dataset.sortValue
    const activeSortValue = currentSortKey || firstTabValue

    this.element.querySelectorAll('[data-sort-value]').forEach(tab => {
      tab.dataset.active = tab.dataset.sortValue === activeSortValue ? '1' : '0'
    })
  }

  setUrl (e, sortId) {
    const currentUrl = new URL(window.location.href)
    const currentParams = new URLSearchParams(currentUrl.search)

    if (sortId && (this.reviewSortValue || sortId !== 'recommended')) {
      currentParams.set(this.parameterName, sortId)
    } else {
      currentParams.delete(this.parameterName)
    }

    currentParams.delete('page')

    currentUrl.search = currentParams.toString()
    return currentUrl.toString()
  }

  clickTab (e) {
    const sortId = e.currentTarget.dataset.sortValue
    location.href = this.setUrl(e, sortId)
  }
}
